/*@flow*/
import type { Element } from 'react';
import React, { Component } from 'react';

export default class ClickOutside extends Component<{
  children: React$Node,
  onClickOutside: Function,
}> {
  container: ?HTMLElement;

  render(): Element<'span'> {
    const { children, onClickOutside, ...props } = this.props; // eslint-disable-line no-unused-vars
    return (
      <span
        {...props}
        ref={(ref) => {
          if (ref) {
            this.container = ref;
          }
        }}
      >
        {children}
      </span>
    );
  }

  componentDidMount() {
    document.addEventListener('click', this.handle, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handle, true);
  }

  handle: (e: MouseEvent) => void = (e: MouseEvent) => {
    const { onClickOutside } = this.props;
    const target = ((e.target: any): Node);
    const el = this.container;
    if ((el && el === target) || (el && !el.contains(target))) {
      onClickOutside(e);
    }
  };
}
